export enum ComponentChangeType {
  ADDED = "added",
  UPDATED = "updated",
  DELETED = "deleted",
  HOVERED = "hovered"
}
export type ComponentChangeTypeValues = `${ComponentChangeType}`;
